import { ContractSellerEditFormValues } from "./types";

export const initialContractSellerEditForm: ContractSellerEditFormValues = {
  sellerCompanyName: null,
  sellerPersonalIdentificationNumber: null,
  sellerHeadquartersAddress: null,
  sellerSalesPersonName: null,
  sellerPhoneNumber: null,
  sellerTransactionAccountNumber: null,
};
